if (!customElements.get('product-tabs-native')) {
  customElements.define(
    'product-tabs-native',
    class ProductTabsNative extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => this.onKey(e, i));
        });
      }
      onKey(e, i) {
        const n = this.tabs.length;
        let next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }
      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
          if (panel) panel.hidden = !on;
        });
        if (focus) this.tabs[index].focus();
      }
    }
  );
}
